// extracted by mini-css-extract-plugin
export var legendIndicator = "_gu-1";
export var legendRight = "_gu-0";